/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AlertModalCreateMutationVariables = {|
  slugName: string,
  description?: ?string,
|};
export type AlertModalCreateMutationResponse = {|
  +warningCreate: ?{|
    +warning: ?{|
      +id: string,
      +slugName: string,
      +icon: ?string,
    |}
  |}
|};
export type AlertModalCreateMutation = {|
  variables: AlertModalCreateMutationVariables,
  response: AlertModalCreateMutationResponse,
|};
*/


/*
mutation AlertModalCreateMutation(
  $slugName: String!
  $description: String
) {
  warningCreate(input: {slugName: $slugName, description: $description}) {
    warning {
      id
      slugName
      icon
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slugName",
    "type": "String!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "description",
    "type": "String"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "description",
            "variableName": "description"
          },
          {
            "kind": "Variable",
            "name": "slugName",
            "variableName": "slugName"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "WarningCreatePayload",
    "kind": "LinkedField",
    "name": "warningCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "WarningNode",
        "kind": "LinkedField",
        "name": "warning",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slugName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "icon",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AlertModalCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AlertModalCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "AlertModalCreateMutation",
    "operationKind": "mutation",
    "text": "mutation AlertModalCreateMutation(\n  $slugName: String!\n  $description: String\n) {\n  warningCreate(input: {slugName: $slugName, description: $description}) {\n    warning {\n      id\n      slugName\n      icon\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5eb8ebca716decc1f1662c3749483d6e';

module.exports = node;
